import React from 'react';
import {PreviousNotesV2} from '../notes/PreviousNotesV2';
import {useHandoverNotesData} from '../../pages/HandoverNotesPage/HandoverNotes';

export const RiskNotesAtrNotes = () => {
  const {data} = useHandoverNotesData();
  return (
    <PreviousNotesV2
      page="Attitude to risk"
      allPreviousNotes={data?.previousNotes || []}
    />
  );
};
